module.exports = __webpack_public_path__ + "img/iwaki_map_sp.07600246.png";